// src/pages/Integrations/DeleteMappingModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import type { MappingRecord } from "store/integrations/types";

interface Props {
  show: boolean;
  record: MappingRecord;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteMappingModal: React.FC<Props> = ({
  show,
  record,
  onClose,
  onConfirm,
}) => (
  <Modal isOpen={show} toggle={onClose} centered>
    <ModalHeader toggle={onClose}>Delete Setup</ModalHeader>
    <ModalBody>
      Are you sure you want to delete the setup <strong>{record.name}</strong>?
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button color="danger" onClick={onConfirm}>
        Delete
      </Button>
    </ModalFooter>
  </Modal>
);

export default DeleteMappingModal;
